import React from 'react'
import { exportBatch } from '../../api/endpoints/batch';

const Excel = ({ batchId}) => {
  const downloadExcel = async() => {
    const response = await exportBatch(batchId);
    if(response.data.success === true){
      const link = document.createElement('a');
      link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.data}`;
      link.download = 'export.xlsx';
      link.click();
    }
  }
  return (
    <button type="button" class="btn btn-primary waves-effect waves-light mb-3"  onClick={downloadExcel}>Export Excel</button>
  )
}

export default Excel